/**
 * 授信审核状态
 * 0 :预处理  1 :是否审核风控提交  2 :审核提交    3:审核重传    4:审核环节结束
 */
export const CREDIT_AUDIT_STATUS = {
  /**
   * 需要重传证件
   */
  REUPLOAD: 3,
}

/**
 * 重试状态
 */
export const CREDIT_RETRY_STATUS = {
  /**
   * 正常
   */
  NORMAL: 0,
  /**
   * 不可重试（授信拒绝状态）
   */
  FORBID: 1,
  /**
   * 固定时间内可重试，目前等待中
   */
  WAITING: 2,
  /**
   * 立即可重试
   */
  INSTANT: 3,
  /**
   * 征信及反欺诈拒绝
   */
  CREDIT_AND_ANTI_FRAUD_RETRY: 211,
  /**
   * 电核拒绝
   */
  CALL_RETRY: 212,
  /**
   * 基本信息拒绝
   */
  BASIC_INFORMATION_RETRY: 213,
  /**
   * 审核系统拒绝
   */
  REVIEW_SYSTEM_RETRY: 214,
  /**
   * 统一拒绝（兜底，其他风控拒绝）
   */
  UNIFORM_RETRY: 215,
}

/**
 * 账户 - 锁定码
 */
export const LOCK_CODE = {
  /**
   * 逾期1-29天
   */
  OVERDUE_1: '01',
  /**
   * 逾期30-59天
   */
  OVERDUE_2: '02',
  /**
   * 逾期60-89天
   */
  OVERDUE_3: '03',
  /**
   * 逾期90-209天
   */
  OVERDUE_4: '04',
  /**
   * 逾期210-249天
   */
  OVERDUE_5: '05',
  /**
   * 法律锁定
   */
  LOW_LOCK: '09',
  /**
   * 锁定，因为死亡
   */
  USER_DEAD: '14',
  /**
   * 锁定，预防欺诈
   */
  FRAUD_PREVENTION: '17',
}

/**
 * 授信关单原因
 * 0-正常关单 1-超时关单 2-curp失败关单
 */
export const DEMOTION_CURP = {
  NORMAL: 0,
  OVERTIME: 1,
  CURPFAIL: 2,
}

/**
 * 用户数据来源
 * 0 - none
 * 1 - minsait
 * 2 - didi
 * 3 - minsait&didi
 */
export const USER_FLAG = {
  NONE: 0,
  MINSAIT: 1,
  DIDI: 2,
  ALL: 3,
}
/**
 *  首页1.0迁移2.0用户
 */

export const MIGRATION_MESSAGE = {
  //还款码变更气泡提示
  HOME_INDEX_REPAY_CODE_CHANGE_POINT:
    'HOME_INDEX_REPAY_CODE_CHANGE_POINT',
  // 还款页面变更提示
  REPAY_INDEX_REPAY_CODE_CHANGE_POINT:
    'REPAY_INDEX_REPAY_CODE_CHANGE_POINT',
  //还款方式页面变更提示
  REPAY_WAY_INDEX_REPAY_CODE_CHANGE_POINT:
    'REPAY_WAY_INDEX_REPAY_CODE_CHANGE_POINT',
}

/**
 * 账户层级 - 锁定码
 */
export const ACCOUNT_LOCK_CODE = {
  /**
   * 延滞180天以上
   */
  POSTPONE_A: 'A',
  /**
   * 延滞61天-90天
   */
  POSTPONE_B: 'B',
  /**
   * 延滞31天-60天
   */
  POSTPONE_C: 'C',
  /**
   * 延滞180天以上（业务方发起）
   */
  POSTPONE_M: 'M',
  /**
   * 延滞1-30天
   */
  POSTPONE_P: 'P',
  /**
   * 延滞91天-180天
   */
  POSTPONE_Q: 'Q',
  /**
   * 该卡已经挂失
   */
  POSTPONE_L: 'L',
  /**
   * 注销账户
   */
  CANCEL: 'Z',
  /**
   * 1-30天拖欠
   */
  OVERDUE_2: '2',
  /**
   * 31-60天拖欠
   */
  OVERDUE_3: '3',
  /**
   * 61-90天拖欠
   */
  OVERDUE_4: '4',
  /**
   * 91-120天拖欠
   */
  OVERDUE_5: '5',
  /**
   * 121-150天拖欠
   */
  OVERDUE_6: '6',
  /**
   * 151-180天拖欠
   */
  OVERDUE_7: '7',
  /**
   * 181-210天拖欠
   */
  OVERDUE_8: '8',
  /**
   * 211以上拖欠
   */
  OVERDUE_9: '9',
}
//人审状态
export const AUDITSTATUS = {
  STATUS: 2,
}
/**
 * 1.0 用户交易关闭状态
 */
export const MINSAIT_SERVICE_STATUS = {
  CLOSING_SOON: 'MIGRATION_REMIND_TRADE_END_TIME_NODE',
  STOP_TRADING: 'MIGRATION_TRADE_END_TIME_NODE',
}

/**
 * 申卡流程标识
 */
export const APPLY_TYPE = {
  /**
   * 1.0 申卡流程
   */
  VERSION_1: 1,
  /**
   * 2.0 申卡流程
   */
  VERSION_2: 2,
  /**
   * 预授信流程
   */
  PRECREDIT: 3,
}

// 预授信AB实验类型, 实验目前全量2 预授信虚实同申
export const PRECREDIT_ABTEST_TYPE = {
  PRECREDIT_VIRTUAL_CARD: 1, // 预授信虚实分离
  PRECREDIT_PHYSICAL_CARD: 2, // 预授信虚实同申
  NORMAL_PHYSICAL_CARD: 3, // 普通流程虚实同申
  NORMAL_VIRTUAL_CARD: 4, // 普通流程虚实分离
}

/**
 * 卡片风格 - 类型
 */
export const CARD_STYLE_CODE = {
  /**
   * 紫黑卡
   */
  BLACK: 0,
  /**
   * 土豪金卡
   */
  METALS: 1,

  /**
   * 后端返回的标识字段cardDesignCode
   * 卡版面代码 A1: 旧卡紫色  B1:新卡金色
   */
  /**
   * 旧卡紫黑卡
   */
  A1: 0,
  /**
   * 新卡金色
   */
  B1: 1,
  /**
   * 新卡金色
   */
  B2: 1,

  CODE_A1: 'A1',
  CODE_B1: 'B1',
  CODE_B2: 'B2',
}

/**
 * 页面
 */
export const APPLY_PAGE = {
  /**
   *  申卡首页
   */
  HOME_INDEX: 1,
  /**
   *  申卡特点页
   */
  HOME_POINT: 2,
  /**
   * 申卡权益页
   */
  HOME_EQUITY: 3,
  /**
   * 安全中心页
   */
  HOME_SECURE: 4,
  /**
   * 营销活动页
   */
  HOME_MARKETING: 5,
}

/**
 * 全首页枚举
 */
export const HOME_LIST = {
  APPLY: 1, // 申卡首页
  PRE_APPLY: 2, // 预授信申卡首页
  VR_DIVIDE_ONE: 3, // 虚实分离首页1
  VR_DIVIDE_TWO: 4, // 虚实分离首页2
  PRE_APPLY_STAGE_TWO: 5, // 预授信二阶段首页
  REFUSE: 6, // 申卡拒绝页
  CARD_WAITING: 7, // 申卡等待页
  WAITING_LIST: 8, // 等候名单页
  REUPLOAD: 9, // 重传页
  CURP_DEMOTION: 10, // curp拒绝页
  BLACK_LIST: 11, // 黑名单首页
  SHORT_REFUSED: 12, // 短期拒绝首页
  USE_CARD: 13, // 用卡首页
  CANCEL: 14, // 销户首页
  STOP: 15, // 停用首页
}

/**
 * 端外申卡首页
 * 100: 端外一阶段初始首页
 * 101: 端外一阶段等待首页
 * 102: 端外一阶段通过首页
 * 103: 端外临时拒绝首页
 * 104: 端外一阶段拒量导流首页
 * 105: 端外永久拒绝首页
 * 106: 端外黑名单首页
 * 107: 端外申卡等待首页
 * 108: 端外特殊KYC场景首页
 * 109: 端外二阶段拒绝期满可重试首页
 * 110:端外统一KYC拦截首页; 
 * 111:端外授信成功首页; 
 * 112: 端外未下卡已注销首页
 * 113: 端外及官网等候名单首页
 * 200: 端外用卡首页
 */
export const EXTERNAL_HOME_LIST = {
  WAITING_LIST: 113,
  APPLY: 100,
  STAGE_ONE_WAITTING: 101,
  STAGE_ONE_PASSED: 102,
  TEMP_REFUSED: 103,
  INTRO_TO_LOAN: 104,
  FOREVER_REFUSED: 105,
  BLACK_LIST: 106,
  APPLY_WAITING: 107,
  SP_KYC: 108,
  RETRY: 109,
  UNIFIED_KYC:110,
  AUTH_SUCCESS: 111,
  NO_CARD_CANCEL_ACCOUNT: 112,
  USE_CARD: 200,

}

/**
 * （新框架申卡卡首页）申请流程类型，
 * 1-1.0申卡；2-普通申卡；3-预授信申卡；4-普通虚实分离申卡；5-预授信虚实分离申卡
 * 6-curp占用普通 7-curp占用预授信
 */
export const OPT_HOME_APPLY_TYPE = {
  v1: 1,
  v2: 2,
  precredit: 3,
  vr_divide: 4,
  vr_divide_precredit: 5,
  curp_conflict_normal: 6,
  curp_conflict_pre: 7,
}

// 首页申卡公参默认兜底值
export const DEFAULT_PAGE = 'homePage'

// 页面类型
export const PAGE_TYPE = {
  APPROVAL: '已持卡',
  DIVERSION: '一阶段拒量导流',
  EXPLAINATION: '风控前置拦截名单',
  PASS: '一阶段通过',
  PERMANENTREJECT: '一二阶段永久拒绝',
  REAPPLY: '二阶段拒绝期结束',
  REJECT: '一二阶段短期拒绝',
  SUBMITTED: '二阶段审批中',
  UPDATE: '二阶段CURP降级补偿不通过或人审需重传',
  WAITING: '一阶段离线等待',
  WAITING_LIST: '等候名单',
  UNIFIED_KYC: '统一kyc',
  CARD_CANCELED: '滴滴卡账号注销页'
}

export const EXPIRED = 'expired'
